import {
  Attribute,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { DirectionService, PlatformService, WindowRefService } from '@hdms/shared/util-core';

import { PreloaderComponentAbstract, PreloaderSchematicType, PreloaderSize } from './preloader-component.abstract';

@Component({
  selector: 'shrd-uic-preloader',
  templateUrl: './preloader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreloaderComponent extends PreloaderComponentAbstract implements OnChanges {
  private static increment = 0;
  private static readonly gradientAniConfig = [
    {
      offset: 0,
      values: [0.2, 0.3, 0.3, 0.2, 0.2, 0.2]
    },
    {
      offset: 50,
      values: [0.2, 0.2, 0.3, 0.3, 0.2, 0.2]
    },
    {
      offset: 100,
      values: [0.2, 0.2, 0.2, 0.3, 0.3, 0.2]
    }
  ];

  private readonly loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private preloaderIsActive = false;

  readonly idSuffix = PreloaderComponent.increment;
  readonly rectCount = Array.from(Array(10).keys());
  readonly gradientAniConfig = PreloaderComponent.gradientAniConfig;
  readonly preloaderSchematicType = PreloaderSchematicType;
  readonly preloaderSize = PreloaderSize;

  @HostBinding('class.preloader') private readonly preloaderCls = true;
  @HostBinding('class.section') private readonly sectionCls = true;

  @HostBinding('class.active')
  @HostBinding('class.initial')
  @HostBinding('class.immediate')
  private immediate: boolean;

  @Input() size: 'medium' | 'small' | 'x-small' = PreloaderSize.M;
  @Input() schematicType: 'paragraph' | 'frame' | 'none' = PreloaderSchematicType.NONE;

  @Input()
  set active(status: boolean) {
    this.loadingSubject.next(status);
  }

  @Output() activeChanged = new EventEmitter<boolean>();

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  set isActive(status: boolean) {
    this.preloaderIsActive = status;
    this.cdr && this.cdr.detectChanges();
    this.activeChanged?.emit(status);
  }

  get isActive(): boolean {
    return this.preloaderIsActive;
  }

  constructor(
    public dir: DirectionService,
    private readonly cdr: ChangeDetectorRef,
    @Attribute('immediate') immediate: boolean,
    winRef: WindowRefService,
    elementRef: ElementRef,
    platformService: PlatformService
  ) {
    super(winRef, platformService);

    PreloaderComponent.increment++;

    this.preloaderElement = elementRef.nativeElement;

    if (typeof immediate === 'string') {
      this.immediate = true;
      this.debounceTime = 0;
    }

    this.createStatusSubscription(this.loadingSubject);
  }

  ngOnChanges({ active }: SimpleChanges): void {
    if (active?.firstChange && active.currentValue === false) {
      this.immediate = false;
    }
  }
}
